import { Passing, RelatedDocuments, Discussion } from "./directories/auxiliary";
import {
  ActionsWithDocuments,
  NomenclatureOfCasesCurrent,
  NomenclatureOfCases,
  ResolutionTemplates,
  DocumentCharacteristics,
  TypesOfReceiptsColumns,
} from "./directories/document-characteristics";
import {
  HrDepartment,
  StructuralUnits,
  Positions,
  EmployeesAndContactPersons,
  DepartmentalJournals,
  GroupsOfCorrespondents,
} from "./directories/hr-department";
import { General } from "./directories/general";
import {
  ConfiguringPageAccess,
  ButtonAccessSettings,
  ServerSettings,
  Users,
  BarcodeApplicationOptions,
  Mailboxes,
  MailboxesByUser,
} from "./administration";
import { MenuTabs } from "./profile";

import type { CheckboxProps } from "antd";

interface FormItemsProps {
  pathname: string;
  onChange: CheckboxProps["onChange"];
}

type RoutesConfig = {
  [key: string]: React.FC<FormItemsProps>;
};

const routesConfig: RoutesConfig = {
  // DOCUMENT CHARACTERISTICS
  "/directories/actions-with-documents": ActionsWithDocuments,
  "/directories/nomenclature-of-cases-current": NomenclatureOfCasesCurrent,
  "/directories/nomenclature-of-cases": NomenclatureOfCases,
  "/directories/resolution-templates": ResolutionTemplates,
  "/directories/types-of-documents": DocumentCharacteristics,
  "/directories/indexes-of-documents": DocumentCharacteristics,
  "/directories/types-of-deliveries": DocumentCharacteristics,
  "/directories/types-of-communication": DocumentCharacteristics,
  "/directories/results-of-actions": DocumentCharacteristics,
  "/directories/document-categories": DocumentCharacteristics,
  "/directories/types-of-relationships-between-documents":
    DocumentCharacteristics,
  "/directories/types-of-receipts": TypesOfReceiptsColumns,
  // HR DEPARTMENT
  "/directories/profession-classifier": HrDepartment,
  "/directories/job-categories": HrDepartment,
  "/directories/types-of-structural-unit": HrDepartment,
  "/directories/employees": EmployeesAndContactPersons,
  "/directories/structural-units": StructuralUnits,
  "/directories/positions": Positions,
  "/directories/groups-of-correspondents": GroupsOfCorrespondents,
  // GENERAL
  "/directories/departmental-journals": DepartmentalJournals,
  "/directories/employees-and-contact-persons": EmployeesAndContactPersons,
  "/directories/correspondents": General,
  // AUXILIARY
  "/directories/passing": Passing,
  "/directories/related-documents": RelatedDocuments,
  "/directories/discussion": Discussion,
  // ADMINISTRATION
  "/administration/configuring-page-access": ConfiguringPageAccess,
  "/administration/button-access-settings": ButtonAccessSettings,
  "/administration/server-settings": ServerSettings,
  "/administration/users": Users,
  "/administration/barcode-application-options": BarcodeApplicationOptions,
  "/administration/mailboxes": Mailboxes,
  "/administration/mailboxes-by-user": MailboxesByUser,
  // PROFILE
  "/profile/menu-tabs": MenuTabs,
};

export default function FormItems({ pathname, onChange }: FormItemsProps) {
  const Component = routesConfig[pathname];

  return Component ? (
    <Component pathname={pathname} onChange={onChange} />
  ) : null;
}
